<template>
	<b-row class="mt-3">
		<b-col cols="12" v-if="problems.length > 0" ><b-table id="problems-table" striped hover :fields="fields" :items="items" stacked="md" /></b-col>
		<b-col cols="6" class="mx-auto text-center"><b-alert show v-if="problems.length == 0">Nincsenek rögzített problémák.</b-alert></b-col>
	</b-row>
</template>

<script>

export default {
	name: 'problem-view',
	props: ['problems'],
	data() {
		return {
			fields:[
				{
				 label: 'Személy',
				 key: 'person_name'
				},
				{
					label: 'azonosító',
					key: 'person_id'
				},
				{
					label: 'Probléma',
					key: 'problem_name'
				},
				{
					label: 'azonosító',
					key: 'problem_id'
				}
			],
			items: []
		}
	},
	methods: {
		flatProblems() {
			this.items = this.problems.map(problem => {
				return {
					person_id: problem.person.id,
					person_name: problem.person.name,
					problem_id: problem.problem.id,
					problem_name: problem.problem.name
				}})
		}
	},
	mounted() {
		setTimeout(this.flatProblems, 1000)
	}
}

</script>